import React, { forwardRef, useEffect, useImperativeHandle } from 'react'
import CustomColumn from '../../../../../customControl/CustomColumn';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { formatDateyearmonthday, getTodayAtMidnight, isBlank } from '../../../../commonClass/CommonValidation';

const ActivityValiditySection = forwardRef(({ ActivityBasicInfoId, ActivityManagePricingId, ActivityName, ActivityValidityForm, setActivityValidityForm, dropdownData, formErrors, setFormErrors, disabled, setEditDisabled }, ref) => {


    const handleDateChange = (name, value) => {
        setEditDisabled(false);
        setFormErrors(null);
        setActivityValidityForm((prev) => ({ ...prev, [name]: value }))
    }

    const ValidateActivityValidityForm = () => {
        let error = {};

        // if (isNullableWithZero?.includes(ActivityBasicInfoId) || isNullableWithZero?.includes(ActivityName)) {
        //     error.ActivityName = "Please select activity from Basic Informatio Tab."
        // }
        if (isBlank?.includes(ActivityValidityForm?.ValidityFromDate)) {
            error.ValidityFromDate = "Input Is mandatory, Cannot Leave Blank."
        }
        if (isBlank?.includes(ActivityValidityForm?.ValidityToDate)) {
            error.ValidityToDate = "Input Is mandatory, Cannot Leave Blank."
        }
        return error;
    }

    // Expose the childFunction to the parent's ref
    useImperativeHandle(ref, () => ({
        canValidate: true,
        ValidateActivityValidityForm: ValidateActivityValidityForm
    }));


    return (
        <>
            <div className="row">

                <div className="col-12">
                    <div className="row">
                        <CustomColumn labelText='Activity Name' labelId='ActivityName'>
                            <input
                                type="text"
                                className='form-control'
                                name="ActivityName"
                                id="ActivityName"
                                // disabled
                                readOnly
                                placeholder='Activity Name'
                                value={ActivityName}
                                onChange={() => { }}
                            />
                            {formErrors?.ActivityName && <div className="text-danger text-start fs_14">{formErrors?.ActivityName}</div>}
                        </CustomColumn>
                    </div>
                </div>
                {/* <CustomColumn labelText='Inventory' labelId='Inventory'>
                    <input
                        type="text"
                        className='form-control'
                        name="Inventory"
                        id="Inventory"
                        disabled
                        placeholder='Inventory'
                        value={1000}
                        onChange={() => { }}
                    />
                </CustomColumn> */}

                <CustomColumn labelText='From' labelId='ValidityFromDate' isRequired>
                    <DatePicker
                        className='antd_input w-100'
                        id='ValidityFromDate'
                        format='DD/MM/YYYY'
                        placeholder="DD/MM/YYYY"
                        minDate={dayjs(formatDateyearmonthday(new Date()))}
                        maxDate={ActivityValidityForm?.ValidityToDate ? dayjs(formatDateyearmonthday(ActivityValidityForm?.ValidityToDate)) : null}
                        value={!isBlank?.includes(ActivityValidityForm?.ValidityFromDate) ? dayjs(formatDateyearmonthday(ActivityValidityForm?.ValidityFromDate)) : null}
                        onChange={(e) => handleDateChange('ValidityFromDate', e ? `${formatDateyearmonthday(e?.$d)}T00:00:00` : null, false)}
                        disabled={disabled || ActivityManagePricingId > 0}
                    />
                    {formErrors?.ValidityFromDate && <div className="text-danger text-start fs_14">{formErrors?.ValidityFromDate}</div>}
                </CustomColumn>
                <CustomColumn labelText='To' labelId='ValidityToDate' isRequired>
                    <DatePicker
                        className='antd_input w-100'
                        id='ValidityToDate'
                        format='DD/MM/YYYY'
                        placeholder="DD/MM/YYYY"
                        minDate={dayjs(
                            formatDateyearmonthday(
                                !isBlank?.includes(ActivityValidityForm?.ValidityFromDate) && new Date(ActivityValidityForm?.ValidityFromDate) > new Date(getTodayAtMidnight())
                                    ? ActivityValidityForm?.ValidityFromDate
                                    : new Date()
                            )
                        )}
                        value={!isBlank?.includes(ActivityValidityForm?.ValidityToDate) ? dayjs(formatDateyearmonthday(ActivityValidityForm?.ValidityToDate)) : null}
                        onChange={(e) => handleDateChange('ValidityToDate', e ? `${formatDateyearmonthday(e?.$d)}T00:00:00` : null, false)}
                        disabled={disabled}
                    />
                    {formErrors?.ValidityToDate && <div className="text-danger text-start fs_14">{formErrors?.ValidityToDate}</div>}
                </CustomColumn>
            </div>
        </>
    )
});

export default ActivityValiditySection